import { render, staticRenderFns } from "./ag-price-weight.vue?vue&type=template&id=ce0a1ae4&scoped=true"
import script from "./ag-price-weight.vue?vue&type=script&lang=js"
export * from "./ag-price-weight.vue?vue&type=script&lang=js"
import style0 from "./ag-price-weight.vue?vue&type=style&index=0&id=ce0a1ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0a1ae4",
  null
  
)

export default component.exports